import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faMinusCircle,
  faPlusCircle,
  faWrench,
  faTrash,
  faFileMedical,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import Desfecho from "../../components/Desfecho/index.jsx";
import { SessionManager } from "../../utils/functions";
import api from "../../services/client/api";
export default function ListReportsCho({
  reports,
  token,
  username,
  showWithoutOutcome,
  refreshReports,
}) {
  const [expanded, setExpanded] = useState(false);
  const [showDesfecho, setShowDesfecho] = useState(false);
  const [desfechoAction, setDesfechoAction] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [reportToDelete, setReportToDelete] = useState(null);

  const session = SessionManager();

  const openConfirmDelete = (report) => {
    setReportToDelete(report);
    setConfirmModal(true);
  };

  const handleRemove = async () => {
    if (!reportToDelete) return;

    try {
      const payload = {
        CodRequisicao: reportToDelete.id_exam,
        username: username,
      };

      const response = await api().user().deleteDesfecho(token, payload);

      if (response.status === 200) {
        setConfirmModal(false);
        setReportToDelete(null);
        await refreshReports();
      }
    } catch (error) {
      console.error("Erro ao remover:", error);
    }
  };

  const download = useCallback(
    async (numberReport, typeReport) => {
      setDownloading(numberReport);

      try {
        const response = await api()
          .report()
          .downloadCho(token, numberReport, typeReport);

        if (response.status === 401) {
          return session.logoff();
        }

        if (response.status === 200) {
          window.open(response.output);
        }
      } catch (error) {
        console.error("Erro no download:", error);
      } finally {
        setDownloading(null);
      }
    },
    [session, token],
  );

  if (!reports || reports.length === 0) return null;

  const mainReport = reports[0];
  const hasMore = reports.length > 1;

  const openDesfecho = (report, action) => {
    setShowDesfecho(true);
    setDesfechoAction(action);
  };

  const handleCloseDesfecho = () => {
    setShowDesfecho(false);
  };

  const formatDateBR = (date) => {
    if (!date) return "";

    const dateString = String(date).split("T")[0];

    const [year, month, day] = dateString.split("-");

    if (!year || !month || !day) return "";

    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Modal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(!confirmModal)}
      >
        <ModalHeader toggle={() => setConfirmModal(!confirmModal)}>
          Confirmar exclusão
        </ModalHeader>

        <ModalBody style={{ textAlign: "center" }}>
          <b>Tem certeza que deseja remover o desfecho?</b>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmModal(false)}>
            Cancelar
          </Button>

          <Button color="danger" onClick={handleRemove}>
            Remover
          </Button>
        </ModalFooter>
      </Modal>
      {/* Linha principal */}
      <tr>
        <td style={{ textAlign: "center" }}>
          {hasMore && (
            <FontAwesomeIcon
              icon={expanded ? faMinusCircle : faPlusCircle} // usa + quando fechado e − quando expandido
              color="#007DC3"
              style={{ cursor: "pointer", margin: 10, fontSize: 19 }}
              onClick={() => setExpanded(!expanded)}
              title={
                expanded
                  ? "Ocultar outros exames deste paciente."
                  : "Mostrar outros exames deste paciente."
              }
            />
          )}
        </td>

        <td style={{ textAlign: "center" }}>{mainReport.id_exam}</td>

        <td style={{ textAlign: "center" }}>{mainReport.patient}</td>

        <td style={{ textAlign: "center" }}>
          {formatDateBR(mainReport.request_date)}
        </td>
        <td style={{ textAlign: "center" }}>
          {formatDateBR(mainReport.end_date)}
        </td>

        <td style={{ textAlign: "center" }}>
          {showWithoutOutcome ? (
            <Button
              color="primary"
              style={{ whiteSpace: "nowrap" }}
              onClick={() => openDesfecho(mainReport, "insert")}
            >
              <b>
                <FontAwesomeIcon
                  icon={faFileMedical}
                  style={{ marginRight: "4px" }}
                />
                Desfecho
              </b>
            </Button>
          ) : (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "5px" }}
            >
              <Button
                color="primary"
                onClick={() => openDesfecho(mainReport, "update")}
              >
                <FontAwesomeIcon icon={faWrench} title={"Alterar Desfecho"} />
              </Button>

              <Button
                color="danger"
                onClick={() => openConfirmDelete(mainReport)}
              >
                <FontAwesomeIcon icon={faTrash} title={"Remover Desfecho"} />
              </Button>
            </div>
          )}
        </td>

        <td style={{ textAlign: "center" }}>
                   {mainReport.can_download ? (
          <Button
            color="info"
            disabled={downloading === mainReport.id_exam}
            onClick={() => download(mainReport.id_exam, mainReport.type)}
          >
            {downloading === mainReport.id_exam ? (
              <Spinner size="sm" />
            ) : (
              <FontAwesomeIcon
                icon={faDownload}
                title={"Fazer download do Laudo"}
              />
            )}
          </Button>
            ) : (
                    "Documento não quitado"
                  )}
        </td>
        {showDesfecho && (
          <Desfecho
            token={token}
            username={username}
            onClose={handleCloseDesfecho}
            report={{
              ...mainReport,
              CodRequisicao: mainReport.id_exam,
            }}
            action={desfechoAction}
            refreshReports={refreshReports}
          />
        )}
      </tr>
      {/* Linhas expandidas */}
      {expanded &&
        reports.slice(1).map((report, index) => (
          <tr key={index} style={{ backgroundColor: "#f9f9f9" }}>
            <td style={{ textAlign: "center", paddingLeft: 10 }}></td>

            <td style={{ textAlign: "center" }}>{report.id_exam}</td>

            <td style={{ textAlign: "center" }}>{report.patient}</td>

            <td style={{ textAlign: "center" }}>
              {formatDateBR(report.request_date)}
            </td>
            <td style={{ textAlign: "center" }}>
              {formatDateBR(report.end_date)}
            </td>

            <td style={{ textAlign: "center" }}>
              {showWithoutOutcome ? (
                <Button
                  color="primary"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => openDesfecho(report, "insert")}
                >
                  <b>
                    <FontAwesomeIcon
                      icon={faFileMedical}
                      style={{ marginRight: "4px" }}
                    />
                    Desfecho
                  </b>
                </Button>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <Button
                    color="primary"
                    onClick={() => openDesfecho(report, "update")}
                  >
                    <FontAwesomeIcon
                      icon={faWrench}
                      title={"Alterar Desfecho"}
                    />
                  </Button>

                  <Button
                    color="danger"
                    onClick={() => openConfirmDelete(report)}
                  >
                    <FontAwesomeIcon
                      icon={faTrash}
                      title={"Remover Desfecho"}
                    />
                  </Button>
                </div>
              )}
            </td>
            <td style={{ textAlign: "center" }}>
                {report.can_download ? (
              <Button
                color="info"
                disabled={downloading === report.id_exam}
                onClick={() => download(report.id_exam, report.type)}
              >
                {downloading === report.id_exam ? (
                  <Spinner size="sm" />
                ) : (
                  <FontAwesomeIcon
                    icon={faDownload}
                    title={"Fazer download do Laudo"}
                  />
                )}
              </Button>
                ) : (
                    "Documento não quitado"
                  )}
            </td>
            {showDesfecho && (
              <Desfecho
                token={token}
                username={username}
                onClose={handleCloseDesfecho}
                report={{
                  ...report,
                  CodRequisicao: report.id_exam,
                }}
                action={desfechoAction}
                refreshReports={refreshReports}
              />
            )}
          </tr>
        ))}
    </>
  );
}
